import { createUseChoiceAnswer } from 'app/modules/subject';

export const useChoiceMultiAnswer = createUseChoiceAnswer(
  'multiple',
  answers => answers.payload as string[],
  checked => checked,
  (value, checked, payload) =>
    checked ? [...payload, value] : payload.filter(v => v !== value)
);
